import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/partners/page.tsx");
